export const Footer = () => (
  <footer data-testid="footer" className="relative bg-forest-800 border-t border-forest-700 pt-24 pb-10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid md:grid-cols-12 gap-12 pb-16">
        <div className="md:col-span-5">
          <img src="/cascade-logo-long.png" alt="Cascade HR Advisors" className="h-12 w-auto mb-6" />
          <p className="font-serif font-extrabold text-3xl md:text-4xl text-navy leading-tight max-w-md">
            The Oregon Pay Equity Fixer.
          </p>
          <p className="text-sage-300 mt-4 max-w-sm">
            27 years of HR judgment, grounded in Oregon. Compliance that holds up, leadership on retainer.
          </p>
        </div>
        <div className="md:col-span-3 md:col-start-8">
          <p className="text-xs uppercase tracking-[0.2em] text-golden-500 font-semibold mb-5">Services</p>
          <ul className="space-y-3 text-sage-200">
            <li><a href="/pay-equity" className="hover:text-golden-500 transition-colors duration-300">Pay Equity Compliance</a></li>
            <li><a href="/fractional-hr" className="hover:text-golden-500 transition-colors duration-300">Fractional HR Director</a></li>
            <li><a href="/wage-studies" className="hover:text-golden-500 transition-colors duration-300">Wage & Market Studies</a></li>
            <li><a href="/toolkits" className="hover:text-golden-500 transition-colors duration-300">Toolkits</a></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.2em] text-golden-500 font-semibold mb-5">Company</p>
          <ul className="space-y-3 text-sage-200">
            <li><a href="/about" className="hover:text-golden-500 transition-colors duration-300">About Susan</a></li>
            <li><a href="/resources" className="hover:text-golden-500 transition-colors duration-300">Resources</a></li>
            <li><a href="/contact" className="hover:text-golden-500 transition-colors duration-300">Book a Call</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-forest-700 pt-8 flex flex-col md:flex-row justify-between gap-4 text-sm text-sage-400">
        <span>&copy; {new Date().getFullYear()} Cascade HR Advisors. Oregon.</span>
        <span>ORS 652.220 compliance &middot; Fractional HR &middot; Wage studies</span>
      </div>
    </div>
  </footer>
);
